<svelte:head>
    <link rel='stylesheet' href='/global.css'>
    <link rel="stylesheet" type="text/css" href="css/charts.css" />
</svelte:head>

<script>
    import Filter from "./utils/filter.svelte"
    import Chart from "./charts/chart.svelte"
    import Header from "./header.svelte"

    import {
        chartOptions,
        loadSpecialOrFilteredChartData,
        loadMainChartData,
        tooltipFormatter,
        colorStops,
        formatLabels,
        getRanges
    } from '../utils/charts'


    import {
        chartHeight,
        chartMarginBottom,
        plotLineColor
    } from '../utils/general'

    import { onMount } from "svelte";
    import { getContext } from "svelte";

    import {getLocalPropertyId} from "../utils/session";
    import {
        isFilterDefault,
        isDisplayDefault,
        isDatesDefault
    } from "./utils/filter";


    const router = getContext('router');


    let data;
    let chartConfig;
    let earliest;
    let labels = [];
    let totalReviews;

    let filterData = JSON.parse(JSON.stringify(chartOptions));

    let showInfo = false;

    let selectedChart = 'overview';

    let selectedDate = 'all';

    let child;

    onMount(() => {

        assembleChartData();
    });

    let switchChart = (e, name) => {

        let target = e.currentTarget;

        document.querySelectorAll('div.active').forEach(element => {
            if (element != target ) {
                element.classList.remove('active');
            }
        })
        selectedChart = name;

        target.classList.add('active');

        chartConfig = false;

        child.resetFilter(true);

        filterData['filter'] = {
            'platform': 'all',
            'rating': 'all',
            'sentiment': 'all',
            'age': 'all',
            'gender': 'all',
            'origin': 'all'
        }

        assembleChartData();
        selectedDate = 'all';

    };

    let receiveChartOptions = (data) => {

        filterData['filter'] = data.detail['map']['filter'];
        filterData['display'] = data.detail['map']['display'];

        let filtered;
        let isDates = false;
        let specialView = false;

        if (!isFilterDefault(filterData['filter'])) {

            filtered = true;
        }

        if (!isDatesDefault(filterData['dates'], earliest)) {

            isDates = true;
        }

        if (!isDisplayDefault(filterData['display'])) {

            specialView = true;
        }

        if ((isDisplayDefault(filterData['display'])) && (!filtered) && (!isDates)) {

            assembleChartData();

        } else {

            assembleChartData(specialView, filtered, isDates);
        }

    };

    let receiveDateOptions = (data) => {

        filterData['dates']['start'] = data.detail['start']
        filterData['dates']['end'] = data.detail['end']
        selectedDate = data.detail['selected']

        let isDates = true;
        let filtered = true;
        let specialView = true;

        if (isDatesDefault(filterData['dates'], earliest)) {

            isDates = false;
        }

        if (isFilterDefault(filterData['filter'])) {

            filtered = false;
        }

        if (isDisplayDefault(filterData['display'])) {

            specialView = false;
        }

        assembleChartData(specialView, filtered, isDates);

    };

    let assembleChartData = (specialView = false, filtered = false, isDates = false) => {

        let chartId = 'reviews_' + selectedChart;

        let chartType = 'chart';

        let propertyId = getLocalPropertyId();

        if (!specialView && !filtered && !isDates) {

            loadMainChartData(router, false ,chartId, chartType, propertyId, filterData).then((chartData) => {

                data = chartData;

                totalReviews = data['data']['total'];

                if (!earliest) {

                    earliest = chartData['settings']['meta']['earliest'];
                }

                if (filterData['dates']['start'] === 0) {

                    filterData['dates']['start'] = chartData['settings']['meta']['earliest'];
                }

                chartHandler(specialView, filtered, isDates);

            });

        } else {

            if (filterData['dates']['start'] === 0) {

                filterData['dates']['start'] = earliest;
            }

            loadSpecialOrFilteredChartData(router, false ,chartId, chartType, propertyId, filterData).then((chartData) => {

                data['data']['data'] = chartData['data'];
                data['data']['period'] = chartData['period'];
                data['data']['total'] = chartData['total']
                totalReviews = chartData['total'];

                chartHandler(specialView, filtered, isDates);

            });

        }



    };

    let chartHandler = (specialView, filtered, isDates) => {

        if (!totalReviews) {

            chartConfig = false;

            return;
        }

        switch (selectedChart) {

            case 'monthly':

                chartConfig = setupChartMonthly(data['data']);
                break;

            case 'daily':

                chartConfig = setupChartDaily(data['data']);
                break;

            case 'platforms':

                chartConfig = null;

                setTimeout(() => {

                    chartConfig = setupChartPlatforms(data['data']);
                }, 1)

                break;

            default:

                if (specialView || (specialView && filtered)) {

                    chartConfig = setupChartSpecialtiesOverview(data['data']);
                }
                else if (!specialView && filtered || isDates) {

                    chartConfig = setupChartOverview(data['data']);
                }
                else {

                    chartConfig = setupChartOverview(data['data']);
                }

        }

        if (isDates) {

            if (selectedChart === 'platforms') {

                setTimeout(() => {

                    changeChartLabels();
                },1)

                return;
            }

            changeChartLabels();
        }

    };

    let changeChartLabels = () => {

        // let chartData = [];

        if (selectedChart === 'overview') {

            chartConfig['xAxis']['categories'] = formatLabels(data['data']['period']['type'], labels)
        }

        chartConfig['xAxis']['plotLines'] = Array.from({length: labels.length}).map((_, i) => {
            return { color: plotLineColor, width: 1, value: i }
        });

        chartConfig['xAxis']['labels']['step'] = labels.length > 7 ? 2 : 1;

    };

    let setupChartOverview = (data) => {

        labels = [];
        let chartData = [];

        for (const [dpk, dp] of Object.entries(data['data'])) {

            labels.push(dpk);

            chartData.push(
                (dp !== 0) ? dp : null
            );
        }

        return {

            chart: {
                type: 'column',
                backgroundColor: 'transparent',
                height: chartHeight
            },
            title: {
                text: null
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                useHTML: true,
                backgroundColor: null,
                borderWidth: 0,
                shadow: false,
                shared: false,
                formatter: tooltipFormatter
            },
            xAxis: {
                allowDecimals: false,
                categories: labels,
                plotLines: Array.from({length: labels.length}).map((_, i) => {
                    return { color: plotLineColor, width: 1, value: i }
                }),
                lineWidth: 0,
                tickWidth: 0,
                labels: {
                    allowOverlap: false,
                    style: {
                        fontSize: '2.22vh',
                        wordBreak: 'break-all',
                        textOverflow: 'allow'
                    },
                    step: (chartData.length > 14) ? 2 : 1,
                    y: chartMarginBottom
                }
            },
            yAxis: {
                allowDecimals: false,
                gridLineWidth: 0,
                title: null,
                labels: {
                    style: {
                        fontSize: '1.96vh'
                    },
                    step: 2
                }
            },
            plotOptions: {
                column: {
                    maxPointWidth: 20,
                    borderRadius: '0.89vh'
                },
                series: {
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    },
                    animation: {
                        duration: 500
                    }
                }
            },
            series: [
                {
                    name: 'basic',
                    data: chartData,
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: [
                            [0, '#19CEDB'],
                            [1, '#16A7E8']
                        ]
                    }
                }
            ]
        };

    };

    let setupChartSpecialtiesOverview = (data) => {

        let series = [];
        labels = [];
        let chartData;

        if (filterData['display'] === 'all') {

            chartData = [];

            for (const [dpk, dp] of Object.entries(data['data'])) {

                labels.push(dpk);

                chartData.push(
                    (dp !== 0) ? dp : null
                );

            }

            series.push(
                {
                    name: 'basic',
                    data: chartData,
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['basic']
                    }
                }
            );

        } else {

            chartData = (filterData['display'] === 'rating')
                ?  { 'pos': [], 'neu': [], 'neg': [] }
                :  { 'fem': [], 'mal': [], 'ukn': [] };

            for (const [dpk, dp] of Object.entries(data['data'])) {

                labels.push(dpk);

                for (const [catk, cat] of Object.entries(dp)) {

                    if (catk !== 'cum') {

                        chartData[catk].push(
                            (cat !== 0) ? cat : null
                        );

                    }

                }

            }

            for (const catk of Object.keys(chartData)) {

                series.push(
                    {
                        name: catk,
                        data: chartData[catk],
                        color: {
                            linearGradient: {
                                x1: 0, x2: 1, y1: 0, y2: 1
                            },
                            stops: colorStops[catk]
                        }
                    }
                )

            }

        }

        return {
            chart: {
                type: 'column',
                backgroundColor: 'transparent',
                height: chartHeight
            },
            title: {
                text: null
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                useHTML: true,
                backgroundColor: null,
                borderWidth: 0,
                shadow: false,
                shared: false,
                formatter: tooltipFormatter
            },
            xAxis: {
                allowDecimals: false,
                categories: labels,
                plotLines: Array.from({length: labels.length}).map((_, i) => {
                    return { color: plotLineColor, width: 1, value: i }
                }),
                lineWidth: 0,
                tickWidth: 0,
                labels: {
                    allowOverlap: false,
                    style: {
                        fontSize: '2.22vh',
                        wordBreak: 'break-all',
                        textOverflow: 'allow'
                    },
                    step: (labels.length > 14) ? 2 : 1,
                    y: chartMarginBottom
                }
            },
            yAxis: {
                allowDecimals: false,
                gridLineWidth: 0,
                title: null,
                labels: {
                    style: {
                        fontSize: '1.96vh'
                    },
                    step: 2
                }
            },
            plotOptions: {
                column: {
                    maxPointWidth: 20,
                    borderRadius: '0.89vh'
                },
                series: {
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    },
                    animation: {
                        duration: 500
                    }
                }
            },
            series
        }

    };

    let setupChartMonthly = (data) => {

        labels = [];
        let chartData = { 'pos': [], 'neu': [], 'neg': [] };

        let gap = 0.1;

        for (const [dpk, dp] of Object.entries(data['data'])) {

            labels.push(dpk);

            let cum = dp['pos'] + dp['neg'];

            let ranges = getRanges(cum, dp['pos'], dp['neg'], gap)

            chartData['pos'].push(dp['pos']);
            chartData['neu'].push(dp['neu']);
            chartData['neg'].push(dp['neg']);

        }

        labels = formatLabels('monthly', labels);

        return {

            chart: {
                type: 'column',
                backgroundColor: 'transparent',
                height: chartHeight
            },
            title: {
                text: null
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                useHTML: true,
                backgroundColor: null,
                borderWidth: 0,
                shadow: false,
                shared: false,
                formatter: tooltipFormatter
            },
            xAxis: {
                allowDecimals: false,
                categories: labels,
                plotLines: Array.from({length: labels.length}).map((_, i) => {
                    return { color: plotLineColor, width: 1, value: i }
                }),
                lineWidth: 0,
                tickWidth: 0,
                labels: {
                    allowOverlap: true,
                    style: {
                        fontSize: '2.22vh',
                        wordBreak: 'break-all',
                        textOverflow: 'allow'
                    },
                    step: 1,
                    y: chartMarginBottom
                }
            },
            yAxis: {
                allowDecimals: false,
                gridLineWidth: 0,
                title: null,
                labels: {
                    style: {
                        fontSize: '1.96vh'
                    },
                    step: 2
                }
            },
            plotOptions: {
                column: {
                    maxPointWidth: 20,
                    borderRadius: '1.2vh',
                    /*stacking: 'normal'*/
                },
                series: {
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    },
                    animation: {
                        duration: 500
                    }
                }
            },
            series: [
                {
                    id: 'pos',
                    name: 'pos',
                    data: chartData['pos'],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['pos']
                    }
                },
                {
                    id: 'neu',
                    name: 'neu',
                    data: chartData['neu'],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['neu']
                    }
                },
                {
                    id: 'neg',
                    name: 'neg',
                    data: chartData['neg'],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['neg']
                    }
                }
            ]

        };


    };

    let setupChartDaily = (data) => {

        labels = [];
        let chartData = { 'pos': [], 'neu': [], 'neg': [] };

        for (const [dpk, dp] of Object.entries(data['data'])) {

            labels.push(dpk);

            chartData['pos'].push(dp['pos']);
            chartData['neu'].push(dp['neu']);
            chartData['neg'].push(dp['neg']);

        }

        labels = formatLabels('daily', labels);

        return {


            chart: {
                type: 'column',
                backgroundColor: 'transparent',
                height: chartHeight
            },
            title: {
                text: null
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                useHTML: true,
                backgroundColor: null,
                borderWidth: 0,
                shadow: false,
                shared: false,
                formatter: tooltipFormatter
            },
            xAxis: {
                allowDecimals: false,
                categories: labels,
                plotLines: Array.from({length: labels.length}).map((_, i) => {
                    return { color: plotLineColor, width: 1, value: i }
                }),
                lineWidth: 0,
                tickWidth: 0,
                labels: {
                    allowOverlap: true,
                    style: {
                        fontSize: '2.22vh',
                        wordBreak: 'break-all',
                        textOverflow: 'allow'
                    },
                    step: 1,
                    y: chartMarginBottom
                }
            },
            yAxis: {
                allowDecimals: false,
                gridLineWidth: 0,
                title: null,
                labels: {
                    style: {
                        fontSize: '1.96vh'
                    },
                    step: 2
                }
            },
            plotOptions: {
                column: {
                    maxPointWidth: 20,
                    borderRadius: '1.2vh',
                    /*stacking: 'normal'*/
                },
                series: {
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    },
                    animation: {
                        duration: 500
                    }
                }
            },
            series: [
                {
                    id: 'pos',
                    name: 'pos',
                    data: chartData['pos'],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['pos']
                    }
                },
                {
                    id: 'neu',
                    name: 'neu',
                    data: chartData['neu'],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['neu']
                    }
                },
                {
                    id: 'neg',
                    name: 'neg',
                    data: chartData['neg'],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['neg']
                    }
                }
            ]
        }
    };

    let setupChartPlatforms = (data) => {

        labels = [];
        let chartData = [];

        for (const [dpk, dp] of Object.entries(data['data'])) {

            labels.push(dpk);

            chartData.push(
                (dp['pct'] !== 0.0) ? dp['pct'] : null
            );

        }

        labels = formatLabels('platforms', labels);

        return {

            chart: {
                type: 'column',
                polar: true,
                backgroundColor: 'transparent',
                height: chartHeight
            },
            title: {
                text: null
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                useHTML: true,
                backgroundColor: null,
                borderWidth: 0,
                shadow: false,
                shared: false,
                formatter: tooltipFormatter
            },
            xAxis: {
                allowDecimals: false,
                categories: labels,
                lineWidth: 0,
                tickWidth: 0,
                labels: {
                    allowOverlap: true,
                    style: {
                        fontSize: '2.22vh',
                        wordBreak: 'break-all',
                        textOverflow: 'allow'
                    },
                    step: 1
                },
                backgroundColor: '#FFFFFF',
                borderRadius: '50%',
                shadow: {
                    color: 'rgba(119, 119, 119, 0.1)',
                    offsetX: 3,
                    offsetY: 4,
                    width: 20
                }
            },
            yAxis: {
                visible: false,
                allowDecimals: false,
                gridLineWidth: 0,
                title: null,
                labels: {
                    style: {
                        fontSize: '1.96vh'
                    },
                    step: 2
                }
            },
            plotOptions: {
                column: {
                    /*maxPointWidth: 20,*/
                    borderRadius: '1.2vh',
                    stacking: 'normal',
                    groupPadding: 0,
                    minPointLength: 100
                },
                series: {
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    },
                    animation: {
                        duration: 500
                    },
                    pointPadding: 0.02
                }
            },
            series: [
                {
                    id: 'percent',
                    name: 'percent',
                    size: data['total'],
                    data: chartData,
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['percent']
                    }
                }
            ]

        }

    };

    let chartTextContent = {
        'reviews': {
            'overview': {
                'info': {
                    'title': 'Bewertungen - Übersicht',
                    'content': 'Dieses Chart zeigt Ihnen, wie viele Bewertungen Sie während des gewählten Zeitraumes erhalten haben.<br />\n' +
                        '        <br />\n' +
                        '        Darstellungen:\n' +
                        '        <ul>\n' +
                        '            <li><strong>Rating</strong> - zeigt die positiven, neutralen und negativen Bewertungen separat an</li>\n' +
                        '            <li><strong>Geschlecht</strong> - zeigt Bewertungen von Frauen, Männern und unbekannter Herkunft separat an</li>\n' +
                        '        </ul>'
                },
                'data': {
                    'title': 'Übersicht',
                }
            },
            'daily': {
                'info': {
                    'title': 'Bewertungen - Verteilung Wochentage',
                    'content': 'Dieses Chart zeigt Ihnen, wie viele Bewertungen Sie pro Tag während des gewählten Zeitraumes erhalten haben.'
                },
                'data': {
                    'title': 'Verteilung Wochentage',
                }
            },
            'monthly': {
                'info': {
                    'title': 'Bewertungen - Verteilung Monate',
                    'content': 'Dieses Chart zeigt Ihnen, wie viele Bewertungen Sie pro Monat während des gewählten Zeitraumes erhalten haben.'
                },
                'data': {
                    'title': 'Verteilung Monate',
                }
            },
            'platforms': {
                'info': {
                    'title': 'Bewertungen - Verteilung Portale',
                    'content': 'Dieses Chart zeigt Ihnen, wie viele Bewertungen Sie auf jedem verknüpften Portal erhalten haben.'
                },
                'data': {
                    'title': 'Verteilung Portale',
                }
            }
        },
        'keywords': {
            'overview': {
                'info': {
                    'title': 'Keywords - Übersicht',
                    'notice': 'Dieses Chart zeigt Ihnen alle Keywords aus Ihren Bewertungen während des gewählten Zeitraumes an.\n' +
                        '                Ein Schlagwort wird als Keyword gezählt, wenn es mehr als zweimal in Ihren Bewertungen verwendet wurde.<br />\n' +
                        '                <br />\n' +
                        '                Klicken Sie auf ein Keyword oder benutzen Sie das Suchfeld, um detaillierte Charts für ein Keyword anzuzeigen.<br />\n' +
                        '                <br />\n' +
                        '                Darstellungen:\n' +
                        '                <ul>\n' +
                        '                    <li><strong>Top 20</strong> - zeigt die 20 meistbenutzten Keywords an</li>\n' +
                        '                </ul>'
                },
                'data': {
                    'title': 'Keyword - Übersicht',
                }
            }
        },
        // 'errore': {
        //     'de': 'Keine Daten verfügbar.',
        //     'en': 'no data found.',
        // }
        'errore': 'Keine Daten verfügbar.'

    };



</script>


<Header
    startDate={earliest}
    on:dates={receiveDateOptions}
    on:propertychange={() => assembleChartData(false, false, false)}
    keyword={false}
    selected={selectedDate}
/>

{#if data}

    <Filter
            data={data}
            on:filtersMenu={receiveChartOptions}
            bind:this={child}
    />

{/if}


<section>

    <div class="main">

        <div id="chart-stats">

            <div class="stats-item">

                <img class="stats-icon" src="images/icon-stats-reviews.svg" />

                <div class="stats-meta">

                    <div class="stats-title">Bewertungen</div>

                    {#if totalReviews || totalReviews === 0}
                        <div class="stats-num">{totalReviews}</div>
                    {/if}


                </div>

            </div>

        </div>

        <div id="chart-legend">

            {#if filterData['display'] === 'rating' || selectedChart === 'daily' || selectedChart === 'monthly'}
                
                <div class="chart-legend-container" data-display="rating">

                    <div class="legend-item">

                        <img src="images/icon-legend-pos.svg" alt="Icon Pos" />
                        <div class="legend-text">Positive</div>

                    </div>

                    <div class="legend-item">

                        <img src="images/icon-legend-neu.svg" alt="Icon Neu" />
                        <div class="legend-text">Neutrale</div>

                    </div>

                    <div class="legend-item">

                        <img src="images/icon-legend-neg.svg" alt="Icon Neg" />
                        <div class="legend-text">Negative</div>

                    </div>

                </div>
                
            {/if}
            
            {#if filterData['display'] === 'gender'}

                <div class="chart-legend-container" data-display="gender">

                    <div class="legend-item">

                        <img src="images/icon-legend-fem.svg" alt="Icon Fem" />
                        <div class="legend-text">Frauen</div>

                    </div>

                    <div class="legend-item">

                        <img src="images/icon-legend-mal.svg" alt="Icon Mal" />
                        <div class="legend-text">Männer</div>

                    </div>

                    <div class="legend-item">

                        <img src="images/icon-legend-ukn.svg" alt="Icon Ukn" />
                        <div class="legend-text">Unbekannte</div>

                    </div>

                </div>

            {/if}

        </div>

        {#if data}

            <Chart
                    chartType={selectedChart}
                    chartConfig={chartConfig}
                    currentPage="reviews"
                    total={totalReviews}
                    keywordTitle={false}
            />

        {/if}



    </div>

    <div id="chart-list" class="show">

        <div id="chart-icon-trend" class="chart-item type-trend active" data-chartid="reviews_overview" on:click|stopPropagation={(e) => switchChart(e, 'overview')}>

            <div class="item-title">
                Übersicht
            </div>

            <div class="item-icon">
                <img src="images/chart-trend.svg" />
            </div>

        </div>

        <div id="chart-icon-monthly" class="chart-item type-periodic" data-chartid="reviews_monthly" on:click|stopPropagation={(e) => switchChart(e, 'monthly')}>

            <div class="item-title">
                Verteilung <br />Monate
            </div>

            <div class="item-icon">
                <img src="images/chart-periodic.svg" />
            </div>

        </div>

        <div id="chart-icon-daily" class="chart-item type-periodic" data-chartid="reviews_daily" on:click|stopPropagation={(e) => switchChart(e, 'daily')}>

            <div class="item-title">
                Verteilung <br />Wochentage
            </div>

            <div class="item-icon">
                <img src="images/chart-periodicshort.svg" />
            </div>

        </div>

        <div id="chart-icon-platform" class="chart-item type-polar" data-chartid="reviews_platforms" on:click|stopPropagation={(e) => switchChart(e, 'platforms')}>

            <div class="item-title">
                Verteilung <br />Portale
            </div>

            <div class="item-icon">
                <img src="images/chart-polar.svg" />
            </div>

        </div>

    </div>



</section>

<style>


</style>







